/* Discard.tsx generated by @compiled/babel-plugin v0.36.1 */
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./Discard.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */

import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl-next';
import Button from '@atlaskit/button/new';
import WarningIcon from '@atlaskit/icon/core/migration/warning';
import { Text } from '@atlaskit/primitives/compiled';
import VisuallyHidden from '@atlaskit/visually-hidden';
import { AI_MODAL_SCREEN_CLASS } from '../../../utils/constants';
import { FloatingContainer } from '../../components/FloatingContainer/FloatingContainer';
import { Breakpoint, useElementBreakpoints } from '../../hooks/useElementBreakpoints';
import messages from './messages';
var buttonContainerStyles = null;
var discardFloatingContainerStyle = null;
var smallDiscardFloatingContainerStyle = null;
export var DiscardScreen = function DiscardScreen(_ref) {
  var onCancel = _ref.onCancel,
    onDiscard = _ref.onDiscard,
    text = _ref.text;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    containerElement = _useState2[0],
    setContainerElement = _useState2[1];
  var _useElementBreakpoint = useElementBreakpoints(),
    _useElementBreakpoint2 = _slicedToArray(_useElementBreakpoint, 2),
    setBreakpointsElement = _useElementBreakpoint2[0],
    breakpoint = _useElementBreakpoint2[1].breakpoint;
  var setRootContainer = function setRootContainer(element) {
    setContainerElement(element);
    setBreakpointsElement(element);
  };

  // Scroll the discard screen into view if it's not fully visible
  useEffect(function () {
    if (containerElement) {
      containerElement.scrollIntoView({
        block: 'nearest'
      });
    }
  }, [containerElement]);
  return /*#__PURE__*/React.createElement(FloatingContainer, {
    ref: setRootContainer,
    "data-testid": "discard-screen"
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ,
    className: ax(["_zulpu2gc _1e0c1txw _2lx2vrvc _j4orxy5q", breakpoint <= Breakpoint.Small && "_zulppxbi _2lx21bp4", "discard-screen ".concat(AI_MODAL_SCREEN_CLASS)]),
    paddingAdjustments: {
      top: 1,
      bottom: 1
    },
    rainbowBorder: false
  }, /*#__PURE__*/React.createElement(VisuallyHidden, null, formatMessage(messages.warningIconLabel)), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
      alignItems: breakpoint <= Breakpoint.Small ? 'flex-start' : 'center',
      flex: 1,
      // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
      gap: '10px'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
      lineHeight: 1,
      position: 'relative',
      flexShrink: 0,
      // 2px top offset at small breakpoints for better icon-text alignment
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
      top: breakpoint <= Breakpoint.Small ? '-2px' : '0'
    }
  }, /*#__PURE__*/React.createElement(WarningIcon, {
    label: formatMessage(messages.warningIconLabel),
    color: "var(--ds-icon-warning, #E56910)"
  })), /*#__PURE__*/React.createElement(Text, {
    as: "p"
  }, text)), /*#__PURE__*/React.createElement("div", {
    className: ax(["_zulpu2gc _1e0c1txw _1n261g80 _2lx2vrvc _1bahesu3 _4cvr1h6o"])
  }, /*#__PURE__*/React.createElement(Button, {
    testId: "cancel-button",
    spacing: "compact",
    onClick: onCancel,
    type: "button",
    appearance: "subtle"
  }, formatMessage(messages.cancelLabel)), /*#__PURE__*/React.createElement(Button, {
    autoFocus: true,
    testId: "discard-button",
    spacing: "compact",
    onClick: onDiscard,
    type: "button",
    appearance: "warning"
  }, formatMessage(messages.discardLabel))));
};